<template>
    <div>
      <div class="loader" v-if="this.isLoading"></div>   
      <div class="loadertext" v-if="this.isLoading"> {{$t('loadingTxt')}}...</div>   
      <div class="main-wrapper" :class="{'blur-content': this.isLoading}">
          <!--begin::navbar-->
          <navbar-component></navbar-component>
          <!--end::navbar-->
   
  
        <div class="page-wrapper">
  
          <!--begin::content-->
          <div class="page-content">
            <div class="row">
              <div class="col-lg-12 col-xl-12 col-sm-12 col-xs-12 col-md-12">
                <div class="card">
                  
                   <div class="card-header">
                        <!-- <i class="link-icon float-start" data-feather="arrow-left"></i> -->
                         &nbsp;&nbsp;&nbsp;
                        <h6 class="card-title mb-0 float-start" style="padding-left: 25px">{{ $t("edit_master_phone_number") }}</h6>
                        <button
                          class="btn btn-default float-end"
                          @click="resetForm"
                          type="button"
                        >
                        <i class="link-icon" data-feather="repeat"></i>
                          {{ $t("resetFormTxt") }}
                        </button>
                  </div>
  
                  <div class="card-body">
                  
  
                    <form
                      class="forms-sample"
                      @submit.prevent="submitData"
                      method="POST"
                    >
                      <div class="row">
                      
                      </div>
  
  
                        
                        <div class="row mb-3">
                        <div class="col-lg-2">
                        <label for="phone_number" class="col-form-label" style="padding-left: 25px">{{
                            $t("phone_number")
                        }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input
                                type="number"
                                class="form-control"
                                id="phone_number"
                                :placeholder="$t('phone_number')"
                                v-model="forms.phone_number"
                                required
                            />

                            <div v-if="errors.phone_number">
                                <div
                                  v-for="error in errors.phone_number"
                                  :key="error"
                                  class="alert alert-primary"
                                  role="alert"
                                >
                                  <i data-feather="alert-circle"></i>
                                  {{ error }}
                                </div>
                            </div>


                        </div>
                        </div>


                
                        <div class="row mb-3">
                            <div class="col-lg-2">
                            <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">{{
                                $t("phone_name")
                            }}</label>
                            </div>
                            <div class="col-lg-8">
                                <input
                                    type="text"
                                    class="form-control"
                                    id="phone_name"
                                    :placeholder="$t('phone_name')"
                                    v-model="forms.phone_name"
                                    required
                                />

                                <div v-if="errors.phone_name">
                                    <div
                                      v-for="error in errors.phone_name"
                                      :key="error"
                                      class="alert alert-primary"
                                      role="alert"
                                    >
                                      <i data-feather="alert-circle"></i>
                                      {{ error }}
                                    </div>
                                </div>
                        
                            </div>
                        </div>
  
  
                        <div class="row mb-3">
                            <div class="col-lg-2">
                              <label for="status" class="col-form-label" style="padding-left: 25px">{{
                                $t("statusTxt")
                              }}</label>
                            </div>
                            <div class="col-lg-8">

                                <v-select
                                    :options="fetchStatus"
                                    v-model="forms.status"
                                    return-object
                                ></v-select>
      
                              
                                <div v-if="errors.status">
                                    <div
                                      v-for="error in errors.status"
                                      :key="error"
                                      class="alert alert-primary"
                                      role="alert"
                                    >
                                      <i data-feather="alert-circle"></i>
                                      {{ error }}
                                    </div>
                                </div>

                            </div>
                          </div>

                          
                     
                      <div class="card-footer">
                       <button
                          class="
                            btn btn-warning
                            text-black
                            fw-bolder
                            btn-icon-text
                          "
                          @click="backForm"
                          type="button"
                        >
                          <i class="link-icon" data-feather="arrow-left"></i>
                          {{ $t("backMess") }}
                        </button>
                        
                        &nbsp;&nbsp;&nbsp;
                        <button class="btn btn-primary float-end btn-sm" type="submit">
                             <i class="link-icon" data-feather="save"></i>
                          {{ $t("submitFormTxt") }}
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--end::content-->
  
          <!--begin::footer-->
          <footer-component></footer-component>
          <!--end::footer-->
        </div>
      </div>
    </div>
</template>
  
  
  <script>
  import navbarComponent from "@/components/_partials/_navbar";
  import footerComponent from "@/components/_partials/_footer";
  
  export default {
    name: "MasterPhoneNumberEdit",
    props: {},
    components: {
      "navbar-component": navbarComponent,
      "footer-component": footerComponent,
    },
    data() {
      return {
        isLoading: false,
        maxToasts: 100,
        position: "up right",
        closeBtn: true,
        errors: [],
        userData: "",
        companyCode: "",
        fetchStatus:["active", "deactived"],
        forms: { master_phone_number_id: "",
                phone_number: "",
                phone_name: "",
                qr: "",
                waBrowserId: "",
                waSecretBundle: "",
                waToken1: "",
                waToken2: "",
                create_by: "",
                update_by: "",
                created_at: "",
                updated_at: "",
                status: "", 
        },
        company:[],
        role:[],
        permision_role:[],
        fetchUserType:[],
        user_type:[],
      };
    },
    watch: {},
    methods: {
  
      
        resetForm() {
            this.forms.master_phone_number_id = "" ;
            this.forms.phone_number = "" ;
            this.forms.phone_name = "" ;
            this.forms.qr = "" ;
            this.forms.waBrowserId = "" ;
            this.forms.waSecretBundle = "" ;
            this.forms.waToken1 = "" ;
            this.forms.waToken2 = "" ;
            this.forms.create_by = "" ;
            this.forms.update_by = "" ;
            this.forms.created_at = "" ;
            this.forms.updated_at = "" ;
            this.forms.status = "active" ;
    
        },
  
  
        backForm() {
            window.location.href = "/whatsapp/master-phone-number";
        },
  
        loadData(id) {
            const baseURI = this.$settings.endPointWhatsapp + "api/dashboard/master-phone-number/detail/"+id;
            this.isLoading = true;
            return this.$http
            .get(
                baseURI,{ timeout: 10000 }
            )
            .then((response) => {
                this.forms      = response.data.datas;
                this.isLoading = false;
                
            }).catch(error => {
                this.isLoading = false;
                if(error.code == "ECONNABORTED"){
                this.error(this.$t("check_internet_connection_txt"));
                
                }else{
    
               if (error.response) {
                            if(error.response.status === 422) {
                                    this.errors = error.response.data.errors;
                                    this.resultError(error.response.data.errors);
                            }else if (error.response.status === 401) {
                                this.logout();
                            } else if (error.response.status === 403) {
                                this.$router.push("/authorized-error");
                            }else if (error.response.status === 500) {
                                this.$router.push('/server-error');
                            }else{
                                this.$router.push('/page-not-found');
                            }
                        }
    
                }
            });
        },
        
        submitData() {
            this.fade(true);
 

                const baseURI  =  this.$settings.endPointWhatsapp+"api/dashboard/master-phone-number/update/"+this.forms.master_phone_number_id;
                this.$http.patch(baseURI,this.forms).then((response) => {
                    this.loading();
                    if(response.data.status === 200) {
                    //this.resetForm();
                        this.errors = [];
                        this.success(response.data.datas.messages);
    
                        //window.history.back();
                        var params = this.$onRandom(this.forms.master_phone_number_id);
                        window.location.href = "/whatsapp/master-phone-number/detail/" + params + "?status=200&msg=Successfully";
    
                    }else{
                        this.errors = response.data.errors;
                        this.resultError(response.data.errors);
                    }
                }).catch(error => {
                    this.loading();
                    if (error.response) {
                            if(error.response.status === 422) {
                                    this.errors = error.response.data.errors;
                                    this.resultError(error.response.data.errors);
                            }else if (error.response.status === 401) {
                                this.logout();
                            } else if (error.response.status === 403) {
                                this.$router.push("/authorized-error");
                            }else if (error.response.status === 500) {
                                this.$router.push('/server-error');
                            }else{
                                this.$router.push('/page-not-found');
                            }
                        }
                    //this.resetForm();
                });
        },
  
        logout(){

            const baseURI = this.$settings.endPoint + "user/logout";
            this.$http.get(baseURI, { timeout: 10000 }).then((response) => {
                
            console.log(response);

            });

            this.$logoutUser();
            window.location.href = '/';
        },
        fade(sType) {
            this.isLoading = sType;
        },
  
        loading() {
            this.fade(true);
            setTimeout(() => {
            this.fade(false);
            }, 1000); // hide the message after 3 seconds
        },
  
        resultError(data) {
            var count = Object.keys(data).length;
            for (var x = 0; x < count; x++) {
            var nameOb = Object.keys(data)[x];
            var objectData = data[nameOb];
            for (var y = 0; y < objectData.length; y++) {
                this.error(objectData[y]);
            }
            }
        },
  
        success(kata) {
            const Toast = this.$swal.mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            didOpen: (toast) => {
                toast.addEventListener("mouseenter", this.$swal.stopTimer);
                toast.addEventListener("mouseleave", this.$swal.resumeTimer);
            },
            // onShown: function() {
            //     console.log('asdasdasd');
            //     //window.location.href = '/';
            // }
            });
    
            Toast.fire({
            icon: "success",
            title: kata,
            });
    
        },
  
        error(kata) {
            const Toast = this.$swal.mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            didOpen: (toast) => {
                toast.addEventListener("mouseenter", this.$swal.stopTimer);
                toast.addEventListener("mouseleave", this.$swal.resumeTimer);
            },
            });
            Toast.fire({
            icon: "error",
            title: kata,
            });
        },

        resultErrorExpress(data) {
            
            for (var x = 0; x < data.length; x++) {
                var objectData = data[x] 
                var messsage = objectData.param + " : " + objectData.msg
                this.error(messsage);
            }
        },
  
        fetchIt() {
            const userDatas     = this.$getUserInfo();
            this.detailUser     = userDatas.sub;
            this.companyCode = this.detailUser.company_detail.code;
            // this.permision_role = userDatas.sub.permision_role;
            let rolePermision = [];
            userDatas.sub.permision_role.forEach(function(permision){
            if(permision.permission.controller == 'WaMasterPhoneNumberController'){
                rolePermision = permision;
                // console.log(permision);
            }
            });
    
            if(!rolePermision.method_update){
            this.$router.push("/authorized-error");
            }
            this.permision_role = rolePermision;
    
        },
   
  
      
    },
    events: {},
    created: function () {},
    mounted() {
  
        var params = this.$onBehind(this.$route.params.id);
        this.loadData(params[0]);
        this.fetchIt();

    },
  };
  </script>
  <style scoped>
  button.gm-ui-hover-effect {
    visibility: hidden;
  }
  
  .blur-content{
    filter: blur(5px); 
    pointer-events: none;
    
  }
  </style>